import { createContext } from "react";
import {
  Teammate,
  TeamWithProjects,
  TeamWithProjectsAndDesigns,
} from "../../types";

export interface TeamContextType {
  // one call to get teamwith projects and projects with designs
  team?: TeamWithProjectsAndDesigns;
  teams: TeamWithProjects[];
  isTeamsLoading?: boolean;
  isTeamLoading?: boolean;
  teamId?: string;
  teammates?: Teammate[];
  refetchTeam: (options?: { skipLoading?: boolean }) => Promise<void>;
  refetchTeams: (options?: { skipLoading?: boolean }) => Promise<void>;
  addToTeam: (teamId: string) => Promise<void>;
}

export interface TeamUserConnectedType {
  imageUrl?: string;
  userId: string;
  initials: string;
}

export const TeamContext = createContext<TeamContextType>({
  team: undefined,
  teams: [],
  isTeamLoading: false,
  isTeamsLoading: false,
  teamId: undefined,
  teammates: undefined,
  refetchTeam: () => Promise.resolve(),
  refetchTeams: () => Promise.resolve(),
  addToTeam: () => Promise.resolve(),
});
